import React from "react";
import { Icon } from "rhombus-react";

import "./PreviewName.css";

export function PreviewName({ dependentValues = {}, value }){
	let { type } = dependentValues;
	let iconName = "";

	if (type === "mockup") {
		iconName = "fas fa-table-layout";
	} else if (type === "tia" || type === "basic") {
		iconName = "fas fa-eye";
	}

	return (
		<div className="preview-name-col" >
			<Icon name={iconName} title={type} />
			<span className="preview-name name-overflow" title={value}>{value}</span>
		</div>
	);
}

